import { IotizeACL, ACLRightType } from './iotize-acl';
import { IotizeBundleModel } from './iotize-bundle-model';
import { runInThisContext } from 'vm';
import { SSL_OP_NO_SESSION_RESUMPTION_ON_RENEGOTIATION } from 'constants';

const ANONYMOUS_PROFILE = 'anonymous';
/**
 *
 */
export class IotizeACLGroup {
  public data: any;

  constructor(
    data: any,
    public bundle?: IotizeBundleModel,
  ) {
    this.data = data;
  }

  public toJson() {
    return this.data;
  }

  /**
   * Get acl for a profile
   * @param profileName
   */
  public getByProfileName(profileName: string): IotizeACL {
    let profiles = this.listProfiles();
    for (let profileAcl of profiles) {
      if (profileAcl.username() === profileName) {
        return profileAcl;
      }
    }
    return IotizeACL.create(profileName, this);
  }

  public hasRight(profileName: string, right: ACLRightType): boolean {
    let anonymousProfile = this.getByProfileName(ANONYMOUS_PROFILE);
    if (anonymousProfile && anonymousProfile.hasRight(right)) {
      return true;
    }
    if (profileName !== ANONYMOUS_PROFILE) {
      let profile = this.getByProfileName(profileName);
      if (profile) {
        return profile.hasRight(right);
      }
    }
    return false;
  }

  /**
   * List acl entries for each profile
   */
  public listProfiles(): Array<IotizeACL> {
    if (!this.data.IOTizeACL) {
      return [];
    }
    let entries = [];
    for (let data of this.data.IOTizeACL) {
      entries.push(new IotizeACL(data, this));
    }
    return entries;
  }
}
